import React from "react";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../redux/store";
import { useUscLabel } from "../../../utils/labels";
import { getFeeListSelector } from "../../../utils/externalPriceUtils";
import TaxLocation from "../common/TaxLocation";
import DisclaimerIconWrapper from "../common/DisclaimerIconWrapper";
import { UscDisclaimerType } from "../../../../shared-logic/types/UscCommonTypes";
import Text from "../styles/atoms/Text";
import Card from "../styles/molecules/Card";
import List from "../styles/atoms/List";
import * as PdpServicesStyles from "../pdp/services/PdpServices.styles";
import * as Styles from "./IncludedFeeList.styles";
import * as CardStyles from "../styles/molecules/Card.styles";
import { UscTrackingLocation } from "../../../utils/tracking";

// List of included taxes/fees
const IncludedFeeList = (): JSX.Element | null => {
    const includedTaxes = useUscSelector(getFeeListSelector("included"), shallowEqual);
    const taxesTitle = useUscLabel("uscTaxesAndCostsTitle");

    if (!includedTaxes.length) return null;

    return (
        <PdpServicesStyles.Wrapper>
            <Text tag="h2" variant="h4">
                {taxesTitle}
            </Text>
            <Card variant="pack">
                <CardStyles.Body>
                    <Styles.IncludedFeeWrapper>
                        <TaxLocation trackingLocation={UscTrackingLocation.Extras} />
                        <List variant="specs">
                            {includedTaxes.map((data) => (
                                <li key={data.key}>
                                    <Styles.InlineTextIcon>
                                        <Text variant="paragraph-small-book">{data.label}</Text>
                                        {!!data.disclaimer && (
                                            <DisclaimerIconWrapper
                                                type={UscDisclaimerType.ExternalPrice}
                                                reference={data.key}
                                            />
                                        )}
                                    </Styles.InlineTextIcon>
                                    <Text tag="div" variant="paragraph-small-book">
                                        <div dangerouslySetInnerHTML={{ __html: data.formattedPrice }} />
                                    </Text>
                                </li>
                            ))}
                        </List>
                    </Styles.IncludedFeeWrapper>
                </CardStyles.Body>
            </Card>
        </PdpServicesStyles.Wrapper>
    );
};

export default IncludedFeeList;
